module.exports = __webpack_public_path__ + "static/TruenoExBd-a13d4c182d22c88367359ea120fe7a68.woff";